export const ACKNOWLEDGEMENT_ALERT_LABELS = {
  acknowledgement_ok: 'Up to date',
  no_acknowledgement: 'Not sent',
  pending_acknowledgement: 'Pending signature',
  acknowledgement_out_of_date: 'Overdue',
  job_profile_id_changed: 'Profile change',
  job_profile_content_changed: 'Profile change',
};

export const ACKNOWLEDGEMENT_ALERT_ICONS = {
  acknowledgement_ok: 'flsa-check-circle-outline',
  no_acknowledgement: 'flsa-file-x',
  acknowledgement_out_of_date: 'flsa-timer-sand-complete',
  pending_acknowledgement: 'ack-clock-outline',
  job_profile_id_changed: 'ack-file-exchange-outline',
  job_profile_content_changed: 'ack-file-exchange-outline',
};

export const getAcknowledgementAlertLabel = (statusKey) => (
  ACKNOWLEDGEMENT_ALERT_LABELS[statusKey] || '—'
);

export const ACKNOWLEDGEMENT_PREVIEW_BANNER_CONFIG = {
  no_acknowledgement: {
    variant: 'error',
    icon: ACKNOWLEDGEMENT_ALERT_ICONS.no_acknowledgement,
    title: ACKNOWLEDGEMENT_ALERT_LABELS.no_acknowledgement,
  },
  pending_acknowledgement: {
    variant: 'grey',
    icon: ACKNOWLEDGEMENT_ALERT_ICONS.pending_acknowledgement,
    title: ACKNOWLEDGEMENT_ALERT_LABELS.pending_acknowledgement,
  },
  acknowledgement_out_of_date: {
    variant: 'warning',
    icon: ACKNOWLEDGEMENT_ALERT_ICONS.acknowledgement_out_of_date,
    title: ACKNOWLEDGEMENT_ALERT_LABELS.acknowledgement_out_of_date,
  },
  job_profile_id_changed: {
    variant: 'info',
    icon: ACKNOWLEDGEMENT_ALERT_ICONS.job_profile_id_changed,
    title: ACKNOWLEDGEMENT_ALERT_LABELS.job_profile_id_changed,
  },
  job_profile_content_changed: {
    variant: 'info',
    icon: ACKNOWLEDGEMENT_ALERT_ICONS.job_profile_content_changed,
    title: ACKNOWLEDGEMENT_ALERT_LABELS.job_profile_content_changed,
  },
};

export const getAcknowledgementPreviewBannerConfig = (alertType) => (
  ACKNOWLEDGEMENT_PREVIEW_BANNER_CONFIG[alertType] || null
);
